import React, { useState } from 'react';
import { Dialog, DialogActions } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { Button } from '@michelin/acid-components';
import { ClosableDialogTitle } from 'components/ClosableDialog/ClosableDialogTitle';
import { ClosableDialogContent } from 'components/ClosableDialog/ClosableDialogContent';
import { PriorityLevelsManagement } from './PriorityLevelsManagement';

interface PriorityLevelsManagementModalProps {
  contactId: string,
  contactLevel: string,
  firstName: string,
  lastName: string,
  stNumber: string,
  btNumber: string,
  countryCode: string,
  action: string,
  forceReassign: boolean,
  onClose: any,
  onSave: any,
}

function PriorityLevelsManagementModal(props:PriorityLevelsManagementModalProps) {
  const {
    stNumber,
    btNumber,
    countryCode,
    firstName,
    lastName,
    contactId,
    contactLevel,
    action,
    forceReassign,
    onClose,
    onSave,
  } = props;

  const [data, setData] = useState<any>({});

  const { t } = useTranslation();

  const title = (action === 'assign')
    ? t('Manage Dealer Contact Type Priority Levels for: {{contactFirstName}} {{contactLastName}}', { contactFirstName: firstName, contactLastName: lastName })
    : t('Reassign Contact Type Priority Levels for: {{contactFirstName}} {{contactLastName}}', { contactFirstName: firstName, contactLastName: lastName });

  return (
    <Dialog
      onClose={() => onClose?.()}
      aria-labelledby="customized-dialog-title"
      open
      fullWidth
      maxWidth={false}
      scroll="paper"
      disableBackdropClick
    >
      <ClosableDialogTitle onClose={() => onClose?.()}>
        {title}
      </ClosableDialogTitle>

      <ClosableDialogContent dividers>
        <PriorityLevelsManagement
          contactId={contactId}
          contactLevel={contactLevel}
          stNumber={stNumber}
          btNumber={btNumber}
          countryCode={countryCode}
          action={action}
          forceReassign={forceReassign}
          onSave={() => onSave?.()}
          onChange={(a:any) => {
            setData(a);
          }}
        />
      </ClosableDialogContent>
      <DialogActions>
        {data.showReassign ? (
          <Button
            size="small"
            color={data.allowReassign ? 'primary' : 'secondary'}
            style={{ margin: '8px' }}
            onClick={data.allowReassign ? () => data.startReassign() : undefined}
          >
            {t('Reassign')}
          </Button>
        ) : null}
        {data.showSave ? (
          <Button
            size="small"
            color={data.allowSave ? 'primary' : 'secondary'}
            style={{ margin: '8px' }}
            onClick={data.allowSave ? async () => { await data.saveChanges(); } : undefined}
          >
            {t('Save')}
          </Button>
        ) : null}
        <Button
          size="small"
          color={data.allowClose ? 'danger' : 'secondary'}
          style={{ margin: '8px' }}
          onClick={() => onClose?.()}
        >
          {t('Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export {
  PriorityLevelsManagementModal,
};
